import React, { Component } from 'react';
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";

export class PrivacyPolicy extends Component {
  constructor(props) {
                        super(props);
                    
                        this.state = {
                          seo: null,
                        };
                      }
                    
                    async componentDidMount() {
                        const seoData = await getSEO("privacy policy");
                    
                        this.setState({
                          seo: seoData,
                        });
            }
  
  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />


        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-4 mb-2 animated slideInLeft">
                  Privacy Policy
                </h1>
                <p className="text-muted">
                  Your data privacy and security is our top priority
                </p>
              </div>
              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link className="text-secondary" to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Privacy Policy
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Content Start */}
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              {/* Section Card */}
              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>1. Introduction</h5>
                <p className="mb-0 text-muted">
                  At Ideal Technoride, we respect your privacy and are committed to protecting your personal information.
                  This policy explains how we collect, use, and safeguard your data.
                </p>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>2. Information We Collect</h5>
                <ul className="mb-0 text-muted">
                  <li>Full Name, Email Address, Phone Number</li>
                  <li>Project requirements and communication details</li>
                  <li>Uploaded documents (Resume, College ID, etc.)</li>
                  <li>Technical data (IP address, browser type)</li>
                </ul>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>3. How We Use Your Information</h5>
                <ul className="mb-0 text-muted">
                  <li>To provide services and respond to inquiries</li>
                  <li>To communicate updates and project details</li>
                  <li>To improve website performance and user experience</li>
                  <li>For internal records and analytics</li>
                </ul>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>4. Data Security</h5>
                <p className="mb-0 text-muted">
                  We implement appropriate technical and organizational measures to protect your data from unauthorized access,
                  misuse, or disclosure.
                </p>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>5. Sharing of Information</h5>
                <p className="mb-0 text-muted">
                  We do not sell or rent your personal data. Information is only used for service delivery and communication purposes.
                </p>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>6. Cookies</h5>
                <p className="mb-0 text-muted">
                  Our website may use cookies to enhance your browsing experience. You can disable cookies in your browser settings.
                </p>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>7. Third-Party Services</h5>
                <p className="mb-0 text-muted">
                  We may use trusted third-party tools (like analytics or email services) that follow their own privacy policies.
                </p>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>8. Your Rights</h5>
                <ul className="mb-0 text-muted">
                  <li>Access your personal data</li>
                  <li>Request correction or deletion</li>
                  <li>Opt-out of communications anytime</li>
                </ul>
              </div>

              <div className="bg-white p-4 mb-4 shadow-sm rounded">
                <h5>9. Policy Updates</h5>
                <p className="mb-0 text-muted">
                  We may update this Privacy Policy from time to time. Changes will be reflected on this page.
                </p>
              </div>

              {/* Contact Box */}
              <div className="bg-primary text-white p-4 rounded mt-5">
                <h5 className="mb-3">Contact Us</h5>
                <p className="mb-1">
                  <i className="fa fa-envelope me-2"></i> idealtechnoride@gmail.com
                </p>
                <p className="mb-0">
                  <i className="fa fa-phone me-2"></i> +91 9820921331
                </p>
              </div>

            </div>
          </div>
        </div>
        {/* Content End */}

      </div>
    );
  }
}

export default PrivacyPolicy;